import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  IGKEksternOgInternRoeykvisualiseringResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
const EksternOgInternRoeykvisualisering: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKEksternOgInternRoeykvisualiseringResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Ekstern og intern røykvisualisering</Title>
        <div className="w-50 mt-0">
          <b>Intern visualisering:</b>
          <div>
            <McTextAreaNew
              label="Beskrivelse av luftstrøm:"
              value={data.inndata.intern.beskrivelseAvLuftstroem}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.eksternOgInternRoeykVisualisering.inndata.intern.beskrivelseAvLuftstroem",
                  e.target.value,
                )
              }
            />
          </div>
          <div>
            <div className="d-flex flex-column">
                            <Radio
                checked={data.inndata.intern.godkjent === true}
                onChange={() =>
                onUpdateEditData("testResultater.eksternOgInternRoeykVisualisering.inndata.intern.godkjent", true)
                }
                label="Godkjent"
              />
                            <Radio
                checked={data.inndata.intern.godkjent === false}
                onChange={() =>
                onUpdateEditData("testResultater.eksternOgInternRoeykVisualisering.inndata.intern.godkjent", false)
                }
                label="Ikke godkjent"
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer
            docxImageTag="internRoeykVisualisering"
            title="Bilde av intern luftstrøm med forstyrrelser"
          />
          <div className="w-50">
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.intern.kommentar}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.eksternOgInternRoeykVisualisering.inndata.intern.kommentar",
                  e.target.value,
                )
              }
            />
          </div>
        </div>
        <div className="w-50 mt-4">
          <b>Ekstern visualisering:</b>
          <div>
            <McTextAreaNew
              label="Beskrivelse av luftstrøm:"
              value={data.inndata.ekstern.beskrivelseAvLuftstroem}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.eksternOgInternRoeykVisualisering.inndata.ekstern.beskrivelseAvLuftstroem",
                  e.target.value,
                )
              }
            />
          </div>
          <div>
            <div className="d-flex flex-column">
                            <Radio
                checked={data.inndata.ekstern.godkjent === true}
                onChange={() =>
                onUpdateEditData("testResultater.eksternOgInternRoeykVisualisering.inndata.ekstern.godkjent", true)
                }
                label="Godkjent"
              />
                            <Radio
                checked={data.inndata.ekstern.godkjent === false}
                onChange={() =>
                onUpdateEditData("testResultater.eksternOgInternRoeykVisualisering.inndata.ekstern.godkjent", false)
                }
                label="Ikke godkjent"
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer
            docxImageTag="eksternRoeykVisualisering"
            title="Bilde av ekstern luftstrøm med forstyrrelser"
          />
          <div className="w-50">
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.ekstern.kommentar}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.eksternOgInternRoeykVisualisering.inndata.ekstern.kommentar",
                  e.target.value,
                )
              }
            />
          </div>
        </div>
      </Stack>
    </Paper>
  );
};
export default EksternOgInternRoeykvisualisering;